import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoneyCoins = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9 12V16C9 17.657 11.686 19 15 19C18.314 19 21 17.657 21 16V12",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 16V20C9 21.657 11.686 23 15 23C16.537 23 17.938 22.71 19 22.235",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 20V24C9 25.657 11.686 27 15 27C16.537 27 17.939 26.711 19 26.236",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 15C18.3137 15 21 13.6569 21 12C21 10.3431 18.3137 9 15 9C11.6863 9 9 10.3431 9 12C9 13.6569 11.6863 15 15 15Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 20V24C19 25.657 21.686 27 25 27C28.314 27 31 25.657 31 24V20",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19 24V28C19 29.657 21.686 31 25 31C28.314 31 31 29.657 31 28V24",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25 23C28.3137 23 31 21.6569 31 20C31 18.3431 28.3137 17 25 17C21.6863 17 19 18.3431 19 20C19 21.6569 21.6863 23 25 23Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
const ForwardRef = forwardRef(SvgMoneyCoins);
export default ForwardRef;
